import './style.scss';

import Tab from 'containers/tab/tab';
// eslint-disable-next-line
import React from 'react';
import { useSelector } from 'react-redux';
import { userType$ } from 'selectors/auth';
import dashboardIcon from 'assets/img/dashboard-icon.png';
import jobBoardIcon from 'assets/img/job-board-icon.png';
import trackCatalogIcon from 'assets/img/track-catalog-icon.png';
import masteringIcon from 'assets/img/mastering-icon.png';
import teamIcon from 'assets/img/team-icon.png';
import playListIcon from 'assets/img/playlist-icon.png';
import microPromotionIcon from 'assets/img/micro-promotion-icon.png';
import netwrkIcon from 'assets/img/netwrk-icon.png';
import musicSubmitIcon from 'assets/img/music-submission-icon.png';
import companyIniviteIcon from 'assets/img/company-invitation-icon.png';
import companyListIcon from 'assets/img/company-list-icon.png';
import userListIcon from 'assets/img/user-list-icon.png';

import styles from './switchTabs.module.scss';

export interface ITab {
  index: number;
  name: string;
  classStyle: string;
  title: string;
  icon?: JSX.Element;
  route: string;
  isNew?: boolean;
  hide?: boolean;
}
const managerTabs: ITab[] = [
  {
    index: 0,
    name: 'First Tab',
    classStyle: 'tab company-tab',
    title: 'JOB BOARD',
    icon: <img className={styles.icon} src={jobBoardIcon} alt="Job Board Icon" loading="lazy" />,
    route: '/manager/job/list',
  },
  {
    index: 1,
    name: 'Second Tab',
    classStyle: 'tab company-tab',
    title: 'MUSIC SUBMISSIONS',
    icon: <img className={styles.icon} src={musicSubmitIcon} alt="Music Submission icon" loading="lazy" />,
    route: '/manager/jobs/active',
  },
  {
    index: 2,
    name: 'Third Tab',
    classStyle: 'tab company-tab',
    title: 'COMPANIES',
    icon: <img className={styles.icon} src={companyListIcon} alt="Company List icon" loading="lazy" />,
    route: '/manager/company/list',
  },
  {
    index: 8,
    name: 'MASTERING CHANNEL',
    classStyle: 'tab musician-first-tab',
    title: 'MASTERING CHANNEL',
    icon: <img className={styles.icon} src={masteringIcon} alt="mastering channel icon" loading="lazy" />,
    route: '/mastering-channel',
  },
  {
    index: 3,
    name: 'Fourth Tab',
    classStyle: 'tab company-tab',
    title: 'COMPANY INVITATIONS',
    icon: <img className={styles.icon} src={companyIniviteIcon} alt="Company Invite icon" loading="lazy" />,
    route: '/manager/invite/list',
  },
  // {
  //   index: 4,
  //   name: 'Fifth Tab',
  //   classStyle: 'tab company-tab',
  //   title: 'AFFILIATE',
  //   icon: <ContactMailRoundedIcon className={styles.icon} />,
  //   route: '/affiliate',
  // },
  {
    index: 5,
    name: 'Sixth Tab',
    classStyle: 'tab company-tab',
    title: 'TEAM',
    icon: <img className={styles.icon} src={teamIcon} alt="Team icon" loading="lazy" />,
    route: '/team',
  },
  {
    index: 6,
    name: 'MICRO PROMOTIONS',
    classStyle: 'tab musician-first-tab',
    title: 'MICRO PROMOTIONS',
    icon: <img className={styles.icon} src={microPromotionIcon} alt="Micro Promotion Icon" loading="lazy" />,
    route: '/micro-promotions',
    isNew: true,
  },
  {
    index: 7,
    name: 'NETWRK',
    classStyle: 'tab musician-first-tab',
    title: 'NETWRK',
    icon: <img className={styles.icon} src={netwrkIcon} alt="Netwrk Icon" loading="lazy" />,
    route: '/announce-netwrk',
    isNew: true,
  }
];

const adminTabs: ITab[] = [
  {
    index: 0,
    name: 'Zero Tab',
    classStyle: 'tab company-tab',
    title: 'STATISTICS',
    icon: <img className={styles.icon} src={dashboardIcon} alt="Dashboard Icon" loading="lazy" />,
    route: '/sh_admin/statistics',
  },
  {
    index: 1,
    name: 'First Tab',
    classStyle: 'tab company-tab',
    title: 'MUSIC SUBMISSIONS',
    icon: <img className={styles.icon} src={musicSubmitIcon} alt="Music Submission icon" loading="lazy" />,
    route: '/sh_admin/jobs/active',
  },
  {
    index: 2,
    name: 'Second Tab',
    classStyle: 'tab musician-first-tab',
    title: 'JOB BOARD',
    icon: <img className={styles.icon} src={jobBoardIcon} alt="Job Board Icon" loading="lazy" />,
    route: '/sh_admin/job/list',
  },
  {
    index: 3,
    name: 'Third Tab',
    classStyle: 'tab company-tab',
    title: 'ADMIN PANEL',
    icon: <img className={styles.icon} src={userListIcon} alt="User List Icon" loading="lazy" />,
    route: '/sh_admin/admin',
  },
  {
    index: 4,
    name: 'Fourth Tab',
    classStyle: 'tab company-tab',
    title: 'TEAM',
    icon: <img className={styles.icon} src={teamIcon} alt="Team Icon" loading="lazy" />,
    route: '/team',
  },
  {
    index: 5,
    name: 'Fifth Tab',
    classStyle: 'tab company-tab',
    title: 'COMPANIES',
    icon: <img className={styles.icon} src={companyListIcon} alt="Company List icon" loading="lazy" />,
    route: '/sh_admin/company/list',
  },
];

const creatorsTabs: ITab[] = [
  {
    index: 0,
    name: 'DASHBOARD',
    classStyle: 'tab musician-first-tab',
    title: 'DASHBOARD',
    icon: <img className={styles.icon} src={dashboardIcon} alt="Dashboard Icon" loading="lazy" />,
    hide: false, //true
    route: '/creator/statistic',
  },
  // {
  //   index: 1,
  //   name: 'Second Tab',
  //   classStyle: 'tab musician-second-tab',
  //   title: 'JOB BOARD',
  //   icon: <WorkIcon className={styles.icon} />,
  //   route: '/creator/job/list',
  // },
  {
    index: 1,
    name: 'JOB BOARD',
    classStyle: 'tab musician-first-tab',
    title: 'JOB BOARD',
    icon: <img className={styles.icon} src={jobBoardIcon} alt="Job Board Icon" loading="lazy" />,
    route: '/creator/job/list',
    isNew: false,
  },
  {
    index: 2,
    name: 'TRACK CATALOG',
    classStyle: 'tab musician-first-tab',
    title: 'TRACK CATALOG',
    icon: <img className={styles.icon} src={trackCatalogIcon} alt="Track Catalog Icon" loading="lazy" />,
    route: '/creator/track/list',
  },
  {
    index: 9,
    name: 'MASTERING CHANNEL',
    classStyle: 'tab musician-first-tab',
    title: 'MASTERING CHANNEL',
    icon: <img className={styles.icon} src={masteringIcon} alt="Mastering Channel Icon" loading="lazy" />,
    route: '/mastering-channel',
  },
  // {
  //   index: 3,
  //   name: 'AFFILIATE',
  //   classStyle: 'tab musician-first-tab',
  //   title: 'AFFILIATE',
  //   icon: <ContactMailRoundedIcon className={styles.icon} />,
  //   route: '/affiliate',
  // },
  {
    index: 4,
    name: 'TEAM',
    classStyle: 'tab musician-first-tab',
    title: 'TEAM',
    icon: <img className={styles.icon} src={teamIcon} alt="Team Icon" loading="lazy" />,
    route: '/team',
  },
  // {
  //   index: 5,
  //   name: 'PRICING',
  //   classStyle: 'tab musician-first-tab',
  //   title: 'PRICING',
  //   icon: <PricingIcon className={styles.icon} />,
  //   route: '/pricing',
  // },
  {
    index: 6,
    name: 'PLAYLIST',
    classStyle: 'tab musician-first-tab',
    title: 'PLAYLIST',
    icon: <img className={styles.icon} src={playListIcon} alt="Playlist Icon" loading="lazy" />,
    route: '/creator/playlist',
    isNew: false,
  },
  {
    index: 7,
    name: 'MICRO PROMOTIONS',
    classStyle: 'tab musician-first-tab',
    title: 'MICRO PROMOTIONS',
    icon: <img className={styles.icon} src={microPromotionIcon} alt="Micro Promotion Icon" loading="lazy" />,
    route: '/micro-promotions',
    isNew: true,
  },
  {
    index: 8,
    name: 'NETWRK',
    classStyle: 'tab musician-first-tab',
    title: 'NETWRK',
    icon: <img className={styles.icon} src={netwrkIcon} alt="Netwrk Icon" loading="lazy" />,
    route: '/announce-netwrk',
    isNew: true,
  }
];

const tab = {
  creator: creatorsTabs.map(tab => <Tab key={tab.index} tab={tab} />),
  manager: managerTabs.map(tab => <Tab key={tab.index} tab={tab} />),
  admin: adminTabs.map(tab => <Tab key={tab.index} tab={tab} />),
};

export const SwitchTabs = () => {
  const userType = useSelector(userType$);
  if (userType) return tab[userType];
};
